import React, { Component, Fragment } from 'react';
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import BasicInfo from "./BasicInfo";
import ExtendInfo from "./ExtendInfo";
import Media from "./Media";
import Model from "./../../../../../models/HomestayRoomType"
import isEqual from "lodash/isEqual";
import { UPLOAD_DIRECTORY, DETAIL_ACTIONS, PATHS, FEATURE_FLAGS } from '../../../../../constants/Define';
import { cloneDeep } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
export default class HomestayRoomTypeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
            action: this.props.match.params.id ? DETAIL_ACTIONS.UPDATE : DETAIL_ACTIONS.CREATE,
            homestayRoomType: new Model({ homestayId: this.props.match.params.homestay_id, isActive: true }),
            validation: {},
            isUploading: false,
            isReady: !this.props.match.params.id //Render when create
        };
    }

    onChange = (e) => {
        let params = Func.getValueForm(e);
        const homestayRoomType = this.state.homestayRoomType || {};
        homestayRoomType[params.name] = params.value
        this.setState({ homestayRoomType, isSubmit: false });
    };

    onChangeAmenity = (fieldName, value) => {
        const homestayRoomType = this.state.homestayRoomType;
        homestayRoomType[fieldName] = value;
        this.setState({ homestayRoomType });
    };

    onChangeRoomFeatures = (e) => {
        let params = Func.getValueForm(e);
        const homestayRoomType = this.state.homestayRoomType || {}
        if (params && params.name && params.value) {
            homestayRoomType.setRoomFeatures(params.name, params.value)
            this.setState({ homestayRoomType });
        }
    };

    uploadFileMultiple = (file) => {
        let data = file.target.files;
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        this.setState({
            isUploading: true
        });
        Object.keys(data).map((i) => {
            if (imageValidation.includes(data[i].type)) {
                this.props.onUploadFile({ file: data[i], directory: UPLOAD_DIRECTORY.ROOM_TYPES, isFile: 2 })
            }
        })
    };

    removeImage = (src) => {
        if (!src) return;
        const homestayRoomType = this.state.homestayRoomType;
        homestayRoomType.removeMedia(src)
        this.setState({ homestayRoomType });
    }

    componentDidMount() {
        const { match } = this.props;
        match.params.id && this.props.getHomestayRoomType(match.params.id);
        match.params.id && this.props.getListAmenities();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.uploadState !== prevProps.uploadState && this.props.uploadState.file) {
            const homestayRoomType = this.state.homestayRoomType;
            homestayRoomType.addMedia(this.props.uploadState.file.data.fileUrl)
            this.setState({ homestayRoomType, isUploading: false });
        }
    }

    onClickBack = () => {
        const { match } = this.props;
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            if (Object.keys(match.params).length > 0 && match.params.homestay_id) {
                const path = Func.getPathWithParams(PATHS.HOMESTAY_ROOM_TYPE.LIST.path, { homestay_id: match.params.homestay_id })
                this.props.history.push(path);
            }
        }
    }

    onShowTranslate = (language) => {
        const { homestayRoomType } = this.state;
        homestayRoomType.setTranslate(language.code);
        homestayRoomType.setData();
        this.setState({ homestayRoomType, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const homestayRoomType = cloneDeep(this.state.homestayRoomType);
        const action = DETAIL_ACTIONS[homestayRoomType.id ? 'UPDATE' : 'CREATE'];
        homestayRoomType.setTranslate(undefined, true);
        homestayRoomType.setData();
        this.setState({ homestayRoomType, action });
    }

    onSaveTranslate = () => {
        const { homestayRoomType } = this.state;
        const translateFunction = homestayRoomType.translate.id ? this.props.updateHomestayRoomTypeTranslate : this.props.createHomestayRoomTypeTranslate;
        translateFunction(homestayRoomType, homestayRoomType.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { homestayRoomType } = this.state;
        homestayRoomType.setTranslate(language.code);
        this.props.deleteHomestayRoomTypeTranslate(homestayRoomType, { id: homestayRoomType.id });
    }

    onSubmit = (e) => {
        e.preventDefault();
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else {
                this.setState({
                    isSubmit: true
                });
                this.props.saveHomestayRoomType({ homestayRoomType: this.state.homestayRoomType, props: this.props });
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.homestayRoomTypeState.homestayRoomType && !isEqual(nextProps.homestayRoomTypeState.homestayRoomType, this.props.homestayRoomTypeState.homestayRoomType) && !nextProps.homestayRoomTypeState.isFetching) {
            this.setState({
                homestayRoomType: nextProps.homestayRoomTypeState.homestayRoomType,
                isReady: true,
                loading: false,
                isSubmit: false
            });
        }
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.homestayRoomType.name`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.homestayRoomType.code`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.homestayRoomType, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    render() {
        const { t, match, uploadState, amenityState } = this.props;
        const { action, homestayRoomType, isReady, isSubmit, validation } = this.state;
        const { isFetchingMultiple, isFetching } = uploadState;
        const { amenities } = amenityState;
        return (
            <Fragment>{isReady &&
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'room-types'}
                        titleHeader={Func.capitalizeFirstLetter((`${t(action === DETAIL_ACTIONS.CREATE ? 'action.create' : 'action.update')} ${t('item.homestayRoomType.title')}`).toLowerCase())}
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={homestayRoomType.translations}
                                current={homestayRoomType.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChange({ name: 'languageCode', value: language.code })}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <div className="row">
                        <div className="col-md-6">
                            <BasicInfo action={action} validation={validation} loading={isSubmit} onChange={this.onChange} homestayRoomType={homestayRoomType} />
                        </div>
                        <div className="col-md-6">
                            <ExtendInfo action={action} validation={validation} loading={isSubmit} onChangeRoomFeatures={this.onChangeRoomFeatures} onChange={this.onChange} homestayRoomType={homestayRoomType} amenities={amenities} onChangeAmenity={this.onChangeAmenity} />
                        </div>
                    </div>
                    <HMS.FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={false}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        activeComponent={false}
                        onChangeActive={this.onChange}
                        titleActiveComponent={t(`item.banner.active`)}
                        submitButtonRight={true}
                        statusActiveName={`isEnabled`}
                        statusActive={false}
                    >
                        <HMS.FormWrapperItem>
                            <div className="col-md-12">
                                <Media loading={isFetchingMultiple || isFetching}
                                    removeImage={this.removeImage}
                                    isUploading={isFetchingMultiple || isFetching}
                                    uploadFileMultiple={this.uploadFileMultiple}
                                    onUploadFile={this.props.onUploadFile} homestayRoomType={homestayRoomType}
                                    onChange={this.onChange} />
                            </div>
                        </HMS.FormWrapperItem>
                    </HMS.FormActionComponent>
                </HMS.PageListComponent>
            }
            </Fragment>
        );
    }
}
